import { AppBar, Dialog, DialogContent, DialogTitle, IconButton, Toolbar, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// Full-screen variant ------------------------------------------------------

export const FullScreenDialog = styled(Dialog)({
  zIndex: '1300 !important',
});

export const FullScreenDialogTitle = styled(DialogTitle)({
  padding: 0,
});

export const FullScreenAppBar = styled(AppBar)({
  position: 'relative',
});

export const FullScreenToolbar = styled(Toolbar)({
  height: 70,
});

export const BarTitle = styled('div')(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  width: '100%',
  textAlign: 'center',
  justifyContent: 'center',
  marginLeft: theme.spacing(2),
}));

export const TitleFull = styled(Typography)({
  margin: 0,
  padding: 0,
  lineHeight: 1.2,
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'center',
});

export const ContentWrap = styled(DialogContent)({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
});

// Standard variant ---------------------------------------------------------

export const StandardDialog = styled(Dialog, {
  shouldForwardProp: (prop) => !['isMobile', 'fullHeight', 'paperMaxWidth'].includes(prop),
})(({ theme, isMobile, fullHeight, paperMaxWidth }) => ({
  '& .MuiDialog-paper': {
    width: isMobile ? '100%' : '80%',
    // PFM-2547: callers can override the desktop max width (default 800px) —
    // ShareLinkModal uses 600 to match the mockup.
    maxWidth: !isMobile ? paperMaxWidth || 800 : undefined,
    height: isMobile || fullHeight ? '100%' : undefined,
  },
  ...(isMobile
    ? { padding: 0, width: '100%', margin: '0 auto' }
    : { padding: theme.spacing(4), margin: '0 auto' }),
}));

export const StandardDialogTitle = styled(DialogTitle)(({ theme }) => ({
  textAlign: 'center',
  fontSize: 16,
  marginLeft: theme.spacing(3),
}));

export const StandardDialogContent = styled(DialogContent)({
  overflowY: 'none',
});

export const ModalContent = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ isMobile }) => ({
  ...(isMobile
    ? { minWidth: '100%', height: '100%' }
    : { height: '100%' }),
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  fontSize: 15,
  color: theme.palette.text.primary,
  position: 'absolute',
  top: 8,
  left: 8,
}));
